/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNotNullResourceId: core.serialization.ObjectSchema<
    serializers.IsNotNullResourceId.Raw,
    Truvity.IsNotNullResourceId
> = core.serialization.object({});

export declare namespace IsNotNullResourceId {
    export interface Raw {}
}
